/* eslint-disable */
import ApiService from "@/common/api.service";
import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import authentication from "./authentication";
import "./plugins/vuetify";
import "./registerServiceWorker";
import router from './router';
import store from "./store/store";

import BreadCrumb from "@/components/BreadCrumb.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import Vuetify from "vuetify/lib";
import vuetify from "./plugins/vuetify";

Vue.use(Vuelidate);

window.moment = require('moment');

const Rollbar = require('vue-rollbar');

if (process.env.NODE_ENV === 'production') {
    Vue.use(Rollbar, {
        accessToken: '360e0af567c74bea9a40b2601ebc2c8b',
        captureUncaught: true,
        captureUnhandledRejections: true,
        enabled: true,
        environment: process.env.NODE_ENV,
        payload: {
            client: {
                javascript: {
                    code_version: '1.0',
                    source_map_enabled: true,
                    guess_uncaught_frames: true
                }
            }
        }
    });

    Vue.config.errorHandler = function (err, vm, info) {
        Vue.rollbar.error(err);
    }
}

ApiService.init();

Vue.component('bread-crumb', BreadCrumb);

Vue.filter('formatDatetime', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
    } else {
        return '';
    }
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    } else {
        return '';
    }
});

Vue.use(Vuetify);

export default new Vuetify({})

// options to the toast
let options = {
    position: "bottom-right",
};

Vue.use(Toasted, options);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.config.devtools = true;
Vue.config.performance = true;

authentication.initialize().then(_ => {
    new Vue({
        router,
        store,
        vuetify,
        el: '#app',
        render: (h) => h(App),
    });
})
    .catch(_ => {
        new Vue({
            vuetify,
            router,
            store,
            el: '#app',
            render: (h) => h(App),
        })
    });
